import axiosAgent from './axiosAgent';
import ApiConfig from '../config/ApiConfig';

export const getAdminDashStats = async (courseId) => {
    console.log('course Id', courseId);
    const response = await axiosAgent.get(
        ApiConfig.statistics.getAdminDashStats
    );
    const responseData = response.data.data;
    return responseData;
};

export const getUsersCount = async (courseId) => {
    console.log('course Id', courseId);
    const response = await axiosAgent.get(ApiConfig.statistics.getUsersCount);
    const responseData = response.data.data;
    return responseData;
};
